/* Detailing Distri Run — Club VIP sur le site.
   Lit le programme (seuil + cadeaux) et la carte du client en direct dans la base
   de l'app fidélité (Supabase : get_program, get_card). La carte est dessinée comme
   dans l'app : métal brossé noir, barre rouge = cagnotte. */
(function () {
  "use strict";
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var CFG = {};
  try { CFG = JSON.parse($("#vip-config").textContent); } catch (e) { return; }
  var PROGRAM = CFG.program;
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var EUR = new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" });
  function eur(n) { return EUR.format(Number(n) || 0).replace(/,00\s/, " ").replace(",00", ""); }
  function eur2(n) { return EUR.format(Number(n) || 0); }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) { return null; } }
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }

  /* ---------------------------------------------------------------- données */
  function rpc(name, body) {
    return fetch(CFG.supabaseUrl + "/rest/v1/rpc/" + name, {
      method: "POST",
      headers: { "Content-Type": "application/json", apikey: CFG.key, Authorization: "Bearer " + CFG.key },
      body: JSON.stringify(body || {})
    }).then(function (r) { if (!r.ok) throw new Error("HTTP " + r.status); return r.json(); });
  }
  function stats(client, th) {
    var total = (client.purchases || []).reduce(function (s, p) { return s + Number(p.amount || 0); }, 0);
    var used = (client.redemptions || []).length * th;
    var cycle = Math.max(0, total - used);
    return { total: total, cycle: cycle, available: Math.floor(cycle / th), progress: Math.min(cycle / th, 1), left: Math.max(0, th - cycle), redeemed: (client.redemptions || []).length };
  }
  function cardIdFrom(text) { var m = String(text || "").match(/c-[a-z0-9]{6,40}/i); return m ? m[0].toLowerCase() : null; }

  /* ---------------------------------------------------------------- carte SVG */
  var uid = 0;
  var TICKS = (function () { var t = ""; for (var i = 1; i < 10; i++) { var x = 56 + 744 * i / 10; t += '<line x1="' + x + '" y1="372" x2="' + x + '" y2="380" stroke="#fff" stroke-opacity="' + (i === 5 ? .28 : .12) + '" stroke-width="1.5"/>'; } return t; })();
  function cardSVG(o) {
    var u = "v" + (++uid) + "_";
    var nm = (o.name || "VOTRE NOM").toUpperCase();
    var fs = Math.max(15, Math.min(30, 540 / (nm.length * 1.02)));
    var num = (o.code || "DR-0000").split("-");
    return '<svg class="car-svg vip-card" viewBox="0 0 856 540" role="img" aria-label="Carte Club VIP Detailing Run">' +
      '<defs>' +
      '<clipPath id="' + u + 'clip"><rect width="856" height="540" rx="34"/></clipPath>' +
      '<linearGradient id="' + u + 'bg" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#23262b"/><stop offset=".45" stop-color="#101114"/><stop offset="1" stop-color="#050506"/></linearGradient>' +
      '<radialGradient id="' + u + 'red" cx="1" cy="0" r="1"><stop offset="0" stop-color="#ed1c24" stop-opacity=".42"/><stop offset=".45" stop-color="#ed1c24" stop-opacity=".08"/><stop offset="1" stop-color="#ed1c24" stop-opacity="0"/></radialGradient>' +
      '<linearGradient id="' + u + 'ch" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#8a8d92"/><stop offset=".3" stop-color="#d9dcdf"/><stop offset=".46" stop-color="#ffffff"/><stop offset=".6" stop-color="#b3b6ba"/><stop offset="1" stop-color="#6f7277"/></linearGradient>' +
      '<linearGradient id="' + u + 'edge" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#ffffff" stop-opacity=".55"/><stop offset=".35" stop-color="#8e9196" stop-opacity=".25"/><stop offset=".7" stop-color="#ffffff" stop-opacity=".12"/><stop offset="1" stop-color="#ed1c24" stop-opacity=".6"/></linearGradient>' +
      '<linearGradient id="' + u + 'chip" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#eef0f2"/><stop offset=".5" stop-color="#9da1a6"/><stop offset="1" stop-color="#d4d7da"/></linearGradient>' +
      '<linearGradient id="' + u + 'bar" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stop-color="#7d0d13"/><stop offset=".7" stop-color="#ed1c24"/><stop offset="1" stop-color="#ff5a60"/></linearGradient>' +
      '<linearGradient id="' + u + 'sh" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stop-color="#fff" stop-opacity="0"/><stop offset=".5" stop-color="#fff" stop-opacity=".16"/><stop offset="1" stop-color="#fff" stop-opacity="0"/></linearGradient>' +
      '<filter id="' + u + 'brush" x="0" y="0" width="100%" height="100%"><feTurbulence type="fractalNoise" baseFrequency="0.003 0.9" numOctaves="2" seed="7"/><feColorMatrix values="0 0 0 0 1  0 0 0 0 1  0 0 0 0 1  .16 0 0 0 -.03"/><feComposite in2="SourceGraphic" operator="in"/></filter>' +
      '<filter id="' + u + 'neon" x="-5%" y="-200%" width="110%" height="500%"><feGaussianBlur stdDeviation="5" result="b"/><feMerge><feMergeNode in="b"/><feMergeNode in="SourceGraphic"/></feMerge></filter>' +
      '</defs>' +
      '<g clip-path="url(#' + u + 'clip)">' +
      '<rect width="856" height="540" fill="url(#' + u + 'bg)"/>' +
      '<rect width="856" height="540" fill="#fff" filter="url(#' + u + 'brush)"/>' +
      '<rect width="856" height="540" fill="url(#' + u + 'red)"/>' +
      '<image href="' + esc(CFG.star || "") + '" x="470" y="70" width="430" height="430" opacity=".06"/>' +
      '<path d="M0 430 C 220 380 520 520 856 400 L856 540 L0 540 Z" fill="#000" opacity=".22"/>' +
      '<rect class="sheen" x="-300" y="-100" width="240" height="760" fill="url(#' + u + 'sh)" transform="skewX(-24)"/>' +
      '</g>' +
      '<rect x="1" y="1" width="854" height="538" rx="33" fill="none" stroke="url(#' + u + 'edge)" stroke-width="2"/>' +
      '<rect class="neon" x="3" y="3" width="850" height="534" rx="31" fill="none" stroke="#ed1c24" stroke-width="2" opacity="0" filter="url(#' + u + 'neon)"/>' +
      '<image href="' + esc(CFG.logo || "") + '" x="50" y="44" width="236" height="69"/>' +
      '<text class="k-label" x="806" y="62" text-anchor="end" font-size="14" fill="#9a9ea4">CLUB FIDÉLITÉ</text>' +
      '<text class="k-vip" x="808" y="114" text-anchor="end" font-size="50" fill="url(#' + u + 'ch)">VIP</text>' +
      '<rect x="742" y="126" width="64" height="3" rx="1.5" fill="#ed1c24"/>' +
      '<g transform="translate(58,160)"><rect width="88" height="66" rx="12" fill="url(#' + u + 'chip)"/><path d="M0 22h28M0 44h28M60 22h28M60 44h28M28 0v66M60 0v66M28 33h32" stroke="#6b6f74" stroke-width="2" fill="none"/><rect x="28" y="14" width="32" height="38" rx="6" fill="none" stroke="#6b6f74" stroke-width="2"/></g>' +
      '<g transform="translate(176,193)" fill="none" stroke="#c9ccd0" stroke-width="3.2" stroke-linecap="round" opacity=".8"><path d="M0 -10a14 14 0 0 1 0 20"/><path d="M10 -18a26 26 0 0 1 0 36"/><path d="M20 -26a38 38 0 0 1 0 52"/></g>' +
      '<text class="k-num" x="58" y="300" font-size="34" fill="#000" opacity=".55" dy="2">' + esc(num[0] || "DR") + "  " + esc(num[1] || "") + '</text>' +
      '<text class="k-num" x="58" y="300" font-size="34" fill="url(#' + u + 'ch)">' + esc(num[0] || "DR") + "  " + esc(num[1] || "") + '</text>' +
      '<text class="k-label" x="58" y="352" font-size="15" fill="#9a9ea4">CAGNOTTE</text>' +
      '<text class="k-amt" x="800" y="354" text-anchor="end" font-size="22" fill="#f2f3f5"><tspan class="amt">0 €</tspan><tspan fill="#8e939b" font-size="16"> / ' + esc(eur(o.th)) + '</tspan></text>' +
      '<rect x="56" y="368" width="744" height="16" rx="8" fill="#000" opacity=".55"/>' +
      '<rect x="56" y="368" width="744" height="16" rx="8" fill="none" stroke="#fff" stroke-opacity=".1"/>' +
      '<rect class="bar-fill" x="56" y="368" width="0" height="16" rx="8" fill="url(#' + u + 'bar)" filter="url(#' + u + 'neon)"/>' +
      TICKS +
      '<text class="k-label status" x="58" y="414" font-size="13" fill="#8e939b"></text>' +
      '<text class="k-name" x="58" y="486" font-size="' + fs.toFixed(1) + '" fill="#000" opacity=".6" dy="2">' + esc(nm) + '</text>' +
      '<text class="k-name" x="58" y="486" font-size="' + fs.toFixed(1) + '" fill="url(#' + u + 'ch)">' + esc(nm) + '</text>' +
      '<text class="k-label" x="800" y="458" text-anchor="end" font-size="11" fill="#8e939b">MEMBRE DEPUIS</text>' +
      '<text class="k-num" x="800" y="486" text-anchor="end" font-size="20" fill="#d9dcdf">' + esc(o.since || "--/--") + '</text>' +
      '</svg>';
  }
  // Met à jour la barre et les textes sans redessiner la carte (utilisé au défilement)
  function setCard(svg, amount, th) {
    if (!svg) return;
    var p = Math.max(0, Math.min(1, amount / th)), full = amount >= th;
    var fill = svg.querySelector(".bar-fill");
    fill.setAttribute("width", p > 0 ? Math.max(16, 744 * p).toFixed(1) : 0);
    svg.querySelector(".amt").textContent = eur(Math.round(amount));
    var st = svg.querySelector(".status");
    st.textContent = full ? "CADEAU DÉBLOQUÉ" : "ENCORE " + eur(Math.ceil(th - amount)).toUpperCase() + " AVANT VOTRE CADEAU";
    st.setAttribute("fill", full ? "#ff5a60" : "#8e939b");
    svg.querySelector(".neon").setAttribute("opacity", full ? ".85" : "0");
  }

  /* ---------------------------------------------------------------- programme */
  var ICONS = {
    towels: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"><path d="M4 7h16v3H4zM3 12h18v3.5H3zM4 17.5h16V21H4z"/><path d="M8 7V4.5M16 7V4.5" stroke-linecap="round"/></svg>',
    bottle: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"><path d="M10 2.5h4v3h-4z"/><path d="M9 5.5h6l1.5 3.5V20a1.5 1.5 0 0 1-1.5 1.5H9A1.5 1.5 0 0 1 7.5 20V9z"/><path d="M8 12.5h8M8 16.5h8"/></svg>',
    spray: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" stroke-linecap="round"><path d="M8 7h6l-1 3H9z"/><path d="M14 7h3l2 2M9 10h4l1.5 3v7.5a1 1 0 0 1-1 1H8.5a1 1 0 0 1-1-1V13z"/><path d="M19.5 4.5l.8-.8M21 7h.8M19.5 9.5l.8.8"/></svg>',
    ticket: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" stroke-linecap="round"><path d="M3 7.5A1.5 1.5 0 0 1 4.5 6h15A1.5 1.5 0 0 1 21 7.5V10a2 2 0 0 0 0 4v2.5a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 16.5V14a2 2 0 0 0 0-4z"/><path d="M9.5 14.5l5-5M10 10h.01M14 14h.01"/></svg>'
  };
  function giftIc(g) {
    if (g.image) return '<span class="gicon"><img src="' + esc(/^https?:/.test(g.image) ? g.image : CFG.app + g.image) + '" alt="" loading="lazy" width="56" height="56"></span>';
    if (g.badge) return '<span class="gicon badge-ic">' + esc(g.badge) + '</span>';
    return '<span class="gicon">' + (ICONS[g.icon] || ICONS.ticket) + '</span>';
  }
  function applyProgram(prog) {
    if (!prog || !prog.threshold) return;
    PROGRAM = prog;
    $$("[data-vip-th]").forEach(function (el) { el.textContent = eur(prog.threshold); });
    if (Array.isArray(prog.gifts) && prog.gifts.length) {
      $$("[data-vip-gifts]").forEach(function (box) {
        box.innerHTML = prog.gifts.map(function (g) {
          return '<div class="gift in">' + giftIc(g) + '<span><span class="gn">' + esc(g.name) + '</span><span class="gd">' + esc(g.desc || "") + '</span></span></div>';
        }).join("");
      });
    }
    stages.forEach(function (s) { s.th = prog.threshold; if (s.mode === "static") setCard(s.svg, s.stat * s.th, s.th); });
    if (Array.isArray(prog.gifts)) $$("[data-vip-chips]").forEach(function (box) {
      box.innerHTML = prog.gifts.map(function (g) { return '<span class="vip-gift">' + giftIc(g) + esc(g.name) + '</span>'; }).join("");
    });
    renderMinis();
  }

  /* ---------------------------------------------------------------- scènes (cartes affichées) */
  var stages = $$("[data-vip-stage]").map(function (st) {
    var host = st.querySelector("[data-vip-card]");
    var wrap = st.closest(".vip-stage-wrap");
    host.innerHTML = cardSVG({ th: PROGRAM.threshold });
    var stat = st.getAttribute("data-vip-static");
    return { st: st, host: host, wrap: wrap || st.closest("[data-vip-sec]"), svg: host.querySelector("svg"), th: PROGRAM.threshold, mode: stat != null ? "static" : "demo", stat: Number(stat), cur: 0, amount: 0 };
  });
  function readout(s, amount, msgHtml, label) {
    var w = s.wrap;
    if (!w || !$("[data-vip-amt]", w)) return;
    $("[data-vip-amt]", w).textContent = eur(Math.round(amount));
    if (msgHtml != null) $("[data-vip-msg]", w).innerHTML = msgHtml;
    if (label) $("[data-vip-rl]", w).textContent = label;
    $("[data-vip-readout]", w).classList.toggle("full", amount >= s.th);
  }
  function showClient(data) {
    var c = data.client, th = (data.settings && data.settings.threshold) || PROGRAM.threshold;
    var st = stats(c, th);
    var since = c.createdAt ? String(c.createdAt).slice(5, 7) + "/" + String(c.createdAt).slice(2, 4) : "--/--";
    stages.forEach(function (s) {
      s.mode = "client"; s.th = th;
      s.host.innerHTML = cardSVG({ th: th, name: ((c.firstName || "") + " " + (c.lastName || "")).trim(), code: c.code, since: since });
      s.svg = s.host.querySelector("svg");
      wireTilt(s.st);
      var hello = s.wrap && $("[data-vip-hello]", s.wrap);
      if (hello) hello.hidden = false;
      if (hello)
      hello.innerHTML = '<span class="eyebrow">Bonjour</span><h3 class="chrome">' + esc(c.firstName || "") + '</h3>';
      var from = 0, to = st.cycle;
      if (reduce) { setCard(s.svg, to, th); readout(s, to); }
      else animate(1400, function (t) { var v = from + (to - from) * t; setCard(s.svg, v, th); readout(s, v); });
      readout(s, to, st.available ? "<strong>Cadeau débloqué.</strong> Choisissez-le dans votre carte puis présentez votre bon en boutique." : "Plus que <strong>" + eur2(st.left) + "</strong> d'achats avant de choisir votre cadeau.", "Ma cagnotte");
    });
    $$("[data-vip-cta]").forEach(function (a) { a.textContent = "Ouvrir ma carte"; a.href = CFG.app + "/#" + c.id; a.target = "_blank"; a.rel = "noopener"; });
    var live = $("[data-vip-live]");
    if (live) {
      live.hidden = false;
      live.innerHTML = '<div class="vip-actions"><a class="btn btn-red" href="' + esc(CFG.app + "/#" + c.id) + '" target="_blank" rel="noopener">Ouvrir ma carte et mes cadeaux</a><button type="button" class="btn btn-line" data-vip-forget>Oublier cette carte</button></div>' +
        '<p class="voucher-note">Carte ' + esc(c.code) + ' · total dépensé ' + eur2(st.total) + ' · ' + st.redeemed + ' cadeau' + (st.redeemed > 1 ? "x" : "") + ' reçu' + (st.redeemed > 1 ? "s" : "") + '</p>';
      var f = $("[data-vip-find]"); if (f) f.hidden = true;
    }
    CLIENT = { stats: st, th: th, id: c.id };
    renderMinis();
  }
  var CLIENT = null;
  function animate(ms, fn) {
    var t0 = performance.now();
    (function f(now) { var t = Math.min(1, (now - t0) / ms); fn(1 - Math.pow(1 - t, 3)); if (t < 1) requestAnimationFrame(f); })(t0);
  }

  // Carte de démonstration : la barre se remplit au défilement, la carte s'illumine au palier
  var vh = window.innerHeight;
  window.addEventListener("resize", function () { vh = window.innerHeight; });
  function loop() {
    stages.forEach(function (s) {
      if (s.mode !== "demo") return;
      var r = s.st.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      var target = reduce ? .72 : Math.max(0, Math.min(1, (vh * .92 - r.top) / (vh * .62)));
      s.cur += (target - s.cur) * (reduce ? 1 : .1);
      var amt = s.cur * s.th;
      if (Math.abs(amt - s.amount) > .05) {
        s.amount = amt;
        setCard(s.svg, amt, s.th);
        readout(s, amt, amt >= s.th ? "<strong>Cadeau débloqué !</strong> Avec votre propre carte, c'est ici que vous choisissez votre cadeau." : null);
      }
    });
    if (!reduce) requestAnimationFrame(loop);
  }
  stages.forEach(function (s) { setCard(s.svg, s.mode === "static" ? s.stat * s.th : 0, s.th); });
  if (reduce) loop(); else requestAnimationFrame(loop);

  // Inclinaison 3D + reflet qui suit le doigt ou la souris (comme dans l'app)
  function wireTilt(st) {
    if (st.dataset.tiltWired) return; st.dataset.tiltWired = "1";
    var t = st.querySelector(".tilt");
    st.addEventListener("pointermove", function (e) {
      var r = st.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
      t.style.setProperty("--ry", (x * 22).toFixed(2) + "deg"); t.style.setProperty("--rx", (-y * 14).toFixed(2) + "deg");
      var sh = st.querySelector(".sheen"); if (sh) sh.setAttribute("x", String(Math.round(-300 + (x + .5) * 1300)));
    });
    st.addEventListener("pointerleave", function () {
      t.style.removeProperty("--ry"); t.style.removeProperty("--rx");
      var sh = st.querySelector(".sheen"); if (sh) sh.setAttribute("x", "-300");
    });
  }
  if (!reduce) stages.forEach(function (s) { wireTilt(s.st); });

  /* ---------------------------------------------------------------- panier et fiche produit */
  var cartTotal = 0;
  function renderMinis() {
    var th = PROGRAM.threshold;
    $$("[data-vip-pdp]").forEach(function (el) {
      var price = Number(el.getAttribute("data-price")) || 0;
      if (CLIENT) {
        var now = CLIENT.stats.cycle, after = now + price;
        el.innerHTML = '<span>Ce produit ajoute <b>' + eur2(price) + '</b> à votre cagnotte Club VIP' + (after >= th && now < th ? ' et <b>débloque votre cadeau</b>' : '') + '.</span>' + bar(now, price, th);
      } else {
        el.innerHTML = '<span><b>+' + eur2(price) + '</b> sur votre cagnotte Club VIP · 1 cadeau tous les ' + eur(th) + '. <a href="' + esc(CFG.page || "/pages/club-vip") + '">En savoir plus</a></span>' + bar(0, price, th);
      }
    });
    $$("[data-vip-cart]").forEach(function (el) {
      if (!cartTotal) { el.hidden = true; return; }
      el.hidden = false;
      if (CLIENT) {
        var now = CLIENT.stats.cycle, after = now + cartTotal;
        el.innerHTML = '<span>Cette commande ajoute <b>' + eur2(cartTotal) + '</b> à votre carte VIP' + (after >= th ? ' : <b>cadeau débloqué</b> !' : ' : encore ' + eur2(th - after) + ' avant votre cadeau.') + '</span>' + bar(now, cartTotal, th);
      } else {
        var left = th - (cartTotal % th);
        el.innerHTML = '<span>Avec le Club VIP, cette commande vaut <b>' + eur2(cartTotal) + '</b> sur votre cagnotte' + (cartTotal >= th ? ' : <b>de quoi débloquer un cadeau</b>.' : ', encore ' + eur2(left) + ' avant un cadeau.') + ' <a href="' + esc(CFG.page || "/pages/club-vip") + '">Ma carte</a></span>' + bar(0, cartTotal, th);
      }
    });
  }
  function bar(now, add, th) {
    var a = Math.min(1, now / th) * 100, b = Math.min(1 - a / 100, add / th) * 100;
    return '<div class="vbar"><i style="width:' + a.toFixed(1) + '%"></i><i style="left:' + a.toFixed(1) + '%;width:' + b.toFixed(1) + '%"></i></div>';
  }
  document.addEventListener("ddr:cart", function (e) { cartTotal = e.detail.total || 0; renderMinis(); });
  document.addEventListener("ddr:pdp", renderMinis);

  /* ---------------------------------------------------------------- retrouver sa carte */
  var findForm = $("[data-vip-find]");
  function loadCard(id, fromForm) {
    var msg = $("[data-vip-find-msg]");
    if (msg && fromForm) { msg.className = "find-msg"; msg.textContent = "Recherche de votre carte…"; }
    return rpc("get_card", { card_id: id }).then(function (data) {
      if (!data || !data.client) throw new Error("introuvable");
      ls("ddr-vip-id", id);
      if (data.settings) applyProgram(data.settings);
      showClient(data);
    }).catch(function (err) {
      if (fromForm && msg) { msg.className = "find-msg err"; msg.textContent = err.message === "introuvable" ? "Ce lien ne correspond à aucune carte. Vérifiez-le ou demandez-le en boutique." : "Impossible de joindre le Club VIP pour le moment. Réessayez dans un instant."; }
      if (!fromForm && err.message === "introuvable") ls("ddr-vip-id", null);
    });
  }
  if (findForm) {
    findForm.addEventListener("submit", function (e) {
      e.preventDefault();
      var id = cardIdFrom(findForm.vip.value);
      var msg = $("[data-vip-find-msg]");
      if (!id) { msg.className = "find-msg err"; msg.textContent = "Collez le lien complet de votre carte (il contient #c-…)."; return; }
      loadCard(id, true);
    });
  }
  document.addEventListener("click", function (e) {
    if (!e.target.closest("[data-vip-forget]")) return;
    ls("ddr-vip-id", null);
    location.reload();
  });

  /* ---------------------------------------------------------------- démarrage */
  // Le lien de la carte peut arriver directement : fidelite.html#c-xxxx (bouton « Boutique » de l'app)
  var fromUrl = cardIdFrom(location.hash) || cardIdFrom(new URLSearchParams(location.search).get("carte"));
  if (fromUrl) { ls("ddr-vip-id", fromUrl); try { history.replaceState(null, "", location.pathname); } catch (e) {} }
  var cached = null;
  try { cached = JSON.parse(ss("ddr-vip-program") || "null"); } catch (e) {}
  applyProgram(PROGRAM);
  if (cached) applyProgram(cached);
  rpc("get_program").then(function (prog) { ss("ddr-vip-program", JSON.stringify(prog)); applyProgram(prog); }).catch(function () {});
  var saved = ls("ddr-vip-id");
  if (saved) loadCard(saved, false);
  renderMinis();
  window.DDRVIP = { cardSVG: cardSVG, setCard: setCard };
})();
